import vue from 'vue'

import { email, hex, username, phone, date, secu } from './patterns'

export function validateUsername (val) {
  return username.test(val)
}

export function validateEmail (val) {
  return email.test(val)
}

export function validateHex (val) {
  return hex.test(val)
}

export function validatePhone (val) {
  // console.log('Phone|' + val + '|')
  if (val === '') {
    return true
  } else {
    return phone.test(val)
  }
}

export function validateDate (val) {
  return date.test(val)
}

export function validateSecu (val) {
  // console.log('Secu|' + val + '|')
  if (val === '') {
    return true
  } else {
    return secu.test(val)
  }
}

/**
 * Check if username is unique
 * @param  {String} val
 * @return {Promise}
 */
export function usernameUnique (value) {
  return getUserWithParams('username', value)
}

/**
 * Check if email is unique
 * @param  {String} val
 * @return {Promise}
 */
export function emailUnique (value) {
  return getUserWithParams('email', value)
}

/**
 * Launch request to get users with given params
 * @param  {String} param
 * @param  {String} value
 * @return {Promise}
 */
function getUserWithParams (param, value) {
  let params = {}
  params[param] = value
  return vue.http.get('user', { params })
    .then(
      (response) => response.json().length ? Promise.reject() : Promise.resolve(),
      (error) => console.log(error)
    )
}



// WEBPACK FOOTER //
// ./src/validations/customRules.js